import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  isPublicMarketingPath,
  isGaConfigured,
  isGtmConfigured,
  loadGa4Once,
  loadGtmOnce,
  gaPageView,
} from "@/lib/analytics-loader";

/**
 * Mounts GA4 + GTM only on public marketing routes.
 * Never loads on /cws-admin/*, /dashboard/*, auth flows, or other private paths.
 * Sends only page_path to GA4 — never form contents, addresses, emails, etc.
 */
export const AnalyticsMount = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isPublicMarketingPath(pathname)) return;
    if (isGaConfigured()) {
      loadGa4Once();
      // Wait a tick so gtag is queued before sending the first page_view
      setTimeout(() => gaPageView(pathname), 0);
    }
    if (isGtmConfigured()) loadGtmOnce();
  }, [pathname]);

  return null;
};

export default AnalyticsMount;
